import { IProductPhotosGETModel } from "projects/lib-core-shared/src/public-api";

export class ProductPhotosMapping {
    toApplicationModel(model: IProductPhotosGETModel) {
        return {
            id: model.id,
            fileName: model.fileName,
            sourceUrl: model.sourceUrl,
            publicationStatus: model.publicationStatus,
            isDefault: model.isDefault,
            sortOrder: model.sortOrder,
            isQualityControl: model.isQualityControl,
            watermarked: model.watermarked,
            unwatermarked: model.unwatermarked,
        }
    }
}